import api from './axios';

export const bookingApi = {
  // ── Public booking flow ──
  calendar: (params) => api.get('/bookings/calendar', { params }).then((r) => r.data),
  giggers: (params) => api.get('/bookings/giggers', { params }).then((r) => r.data),
  submit: (payload) => api.post('/bookings', payload).then((r) => r.data),

  // ── Tracking (public, by unguessable tracking id) ──
  track: (trackingId) => api.get(`/track/${trackingId}`).then((r) => r.data),
  trackInvoice: (trackingId) => api.get(`/track/${trackingId}/invoice`).then((r) => r.data),
  requestExtraHours: (trackingId, payload) =>
    api.post(`/track/${trackingId}/extra-hours`, payload).then((r) => r.data),
  cancel: (trackingId, payload) => api.post(`/track/${trackingId}/cancel`, payload).then((r) => r.data),
  review: (trackingId, payload) => api.post(`/track/${trackingId}/review`, payload).then((r) => r.data),
  giggerProfile: (id) => api.get(`/bookings/gigger/${id}`).then((r) => r.data),
  keepWaiting: (trackingId) => api.post(`/track/${trackingId}/keep-waiting`).then((r) => r.data),
  reassign: (trackingId, giggerId) => api.post(`/track/${trackingId}/reassign`, { giggerId }).then((r) => r.data),
  cancelUnfilled: (trackingId) => api.post(`/track/${trackingId}/cancel-unfilled`).then((r) => r.data),
  availableGiggers: (trackingId) => api.get(`/track/${trackingId}/available-giggers`).then((r) => r.data),
  activate: (payload) => api.post('/client/activate', payload).then((r) => r.data), // { email, trackingId, password }

  // ── Authenticated client account ──
  myBookings: () => api.get('/client/bookings').then((r) => r.data),
  clientInvoice: (bookingId) => api.get(`/client/bookings/${bookingId}/invoice`).then((r) => r.data),

  // ── Payments (full booking amount after accept; accepted additional-task payment before work) ──
  createDepositIntent: (trackingId) =>
    api.post(`/track/${trackingId}/deposit-intent`).then((r) => r.data),
  confirmDeposit: (trackingId, paymentIntentId) =>
    api.post(`/track/${trackingId}/deposit-confirm`, { paymentIntentId }).then((r) => r.data),
  createBalanceIntent: (trackingId) =>
    api.post(`/track/${trackingId}/balance-intent`).then((r) => r.data),
  confirmBalance: (trackingId, paymentIntentId) =>
    api.post(`/track/${trackingId}/balance-confirm`, { paymentIntentId }).then((r) => r.data),
};

export default bookingApi;
